import { Component } from '@angular/core';

@Component({
  selector: 'vfs-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent {}
